export default function SingleRank({ user }) {
  return (
    <tr className="border-b border-slate-600/50">
      <td className="table-td text-center">{user.rank}</td>
      <td className="table-td">{user.name}</td>
      <td className="table-td text-center">{user.assignmentmark}</td>
      <td className="table-td text-center">{user.quizemark}</td>
      <td className="table-td text-center">{user.total}</td>
    </tr>
  );
}
